import {
  Alert,
  AlertBody,
  AlertIcon,
  RiErrorWarningLine,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  Stack,
} from 'component-library';
import { TFunction } from 'i18next';

import { PlotType } from '@/api/rest/resources/types/plot';

import { PLOT_LAND_TYPES } from '../constants';

type ManualPlotFormProps = {
  t: TFunction;
  name: string;
  setName: (v: string) => void;
  landType: PlotType | '';
  setLandType: (v: PlotType | '') => void;
  lat: string;
  setLat: (v: string) => void;
  lng: string;
  setLng: (v: string) => void;
  error: string | undefined;
};

export const ManualPlotForm = ({
  t,
  name,
  setName,
  landType,
  setLandType,
  lat,
  setLat,
  lng,
  setLng,
  error,
}: ManualPlotFormProps) => (
  <Stack spacing={5}>
    <Stack spacing={1}>
      <label className='typography-body2Semibold'>{t('shared.uploadCoordinates.manual.plotName')}</label>
      <input
        type='text'
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder={t('shared.uploadCoordinates.manual.plotNamePlaceholder')}
        className='w-full rounded-lg border border-neutral-black-23 px-3 py-2 text-sm outline-none focus:border-primary-100'
      />
    </Stack>

    <Stack spacing={1}>
      <label className='typography-body2Semibold'>{t('shared.uploadCoordinates.manual.landUse')}</label>
      <Select value={landType} onValueChange={(v) => setLandType(v as PlotType)}>
        <SelectTrigger placeholder={t('shared.uploadPlots.landType.placeholder')} />
        <SelectContent>
          {PLOT_LAND_TYPES.map((type) => (
            <SelectItem key={type} value={type}>
              {t(`global.plotTypes.${type}`)}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </Stack>

    <Stack spacing={1}>
      <label className='typography-body2Semibold'>{t('shared.uploadCoordinates.manual.latitude')}</label>
      <input
        type='number'
        value={lat}
        onChange={(e) => setLat(e.target.value)}
        placeholder='00.00000'
        step='0.00001'
        min='-90'
        max='90'
        className='w-full rounded-lg border border-neutral-black-23 px-3 py-2 text-sm outline-none focus:border-primary-100'
      />
    </Stack>

    <Stack spacing={1}>
      <label className='typography-body2Semibold'>{t('shared.uploadCoordinates.manual.longitude')}</label>
      <input
        type='number'
        value={lng}
        onChange={(e) => setLng(e.target.value)}
        placeholder='00.00000'
        step='0.00001'
        min='-180'
        max='180'
        className='w-full rounded-lg border border-neutral-black-23 px-3 py-2 text-sm outline-none focus:border-primary-100'
      />
    </Stack>

    {error && (
      <Alert type='error'>
        <AlertIcon>
          <RiErrorWarningLine size={20} />
        </AlertIcon>
        <AlertBody>{error}</AlertBody>
      </Alert>
    )}
  </Stack>
);
